export default __webpack_public_path__ + "static/media/100_19801.d99937ad.jpg";